import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DetailedAnalysis = ({ analysisData }) => {
  const [activeSection, setActiveSection] = useState(analysisData?.[0]?.id || '');

  const getSectionIcon = (type) => {
    const icons = {
      supply: 'Truck',
      operational: 'Settings',
      equipment: 'Wrench',
      financial: 'DollarSign',
      market: 'TrendingUp',
      governance: 'Shield'
    };
    return icons?.[type] || 'FileText';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center">
          <Icon name="FileSearch" size={20} color="var(--color-secondary)" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">Analisis Detail</h2>
      </div>
      <div className="flex flex-col lg:flex-row gap-6">
        <div className="lg:w-64 flex-shrink-0">
          <div className="space-y-2">
            {analysisData?.map((section) => (
              <button
                key={section?.id}
                onClick={() => setActiveSection(section?.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-all duration-250 ${
                  activeSection === section?.id
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted/50 text-muted-foreground hover:bg-muted'
                }`}
              >
                <Icon name={getSectionIcon(section?.type)} size={20} />
                <span className="text-sm font-medium">{section?.title}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex-1">
          {analysisData?.map((section) => (
            activeSection === section?.id && (
              <div key={section?.id} className="space-y-6">
                <div>
                  <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">{section?.title}</h3>
                  <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-6">
                    {section?.overview}
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {section?.metrics?.map((metric, index) => (
                    <div key={index} className="p-4 rounded-lg bg-muted/50">
                      <div className="flex items-center gap-2 mb-2">
                        <Icon name={metric?.icon} size={16} color="var(--color-muted-foreground)" />
                        <span className="text-xs text-muted-foreground">{metric?.label}</span>
                      </div>
                      <div className="text-2xl font-bold text-foreground data-text">{metric?.value}</div>
                      <div className="text-xs text-muted-foreground mt-1">{metric?.unit}</div>
                    </div>
                  ))}
                </div>

                <div>
                  <h4 className="text-base font-semibold text-foreground mb-3">Temuan Utama</h4>
                  <div className="space-y-3">
                    {section?.findings?.map((finding, index) => (
                      <div key={index} className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
                        <Icon 
                          name={finding?.type === 'positive' ? 'CheckCircle2' : finding?.type === 'warning' ? 'AlertTriangle' : 'XCircle'} 
                          size={18} 
                          color={finding?.type === 'positive' ? 'var(--color-success)' : finding?.type === 'warning' ? 'var(--color-warning)' : 'var(--color-error)'} 
                          className="flex-shrink-0 mt-0.5"
                        />
                        <p className="text-sm text-foreground">{finding?.text}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="text-base font-semibold text-foreground mb-3">Rekomendasi</h4>
                  <div className="space-y-2">
                    {section?.recommendations?.map((rec, index) => (
                      <div key={index} className="flex items-start gap-3 p-3 rounded-lg border border-primary/20 bg-primary/5">
                        <div className="w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0 text-xs font-bold">
                          {index + 1}
                        </div>
                        <p className="text-sm text-foreground">{rec}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailedAnalysis;